import { render, staticRenderFns } from "./CreateContactModal.vue?vue&type=template&id=2fdcbff4&"
import script from "./CreateContactModal.vue?vue&type=script&lang=js&"
export * from "./CreateContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports